import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {IPageData, UIError} from 'common/interfaces';
import {IBrand, IBrandState} from 'common/interfaces/ibrand';

const initialStoreState: IBrandState = {
  brands: null,
  loading: false,
  error: undefined,
};

const reducers = {
  setLoading: (state: IBrandState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: IBrandState, action: PayloadAction<UIError | null>) => {
    state.error = action.payload;
  },
  resetContext: (state: IBrandState) => {
    state = initialStoreState;
  },
  setBrands: (
    state: IBrandState,
    action: PayloadAction<IPageData<IBrand> | null>,
  ) => {
    state.brands = action.payload;
  },
  addBrands: (
    state: IBrandState,
    action: PayloadAction<IPageData<IBrand> | null>,
  ) => {
    if (action.payload) {
      const stStores = state.brands?.items || [];
      const payLoadStores = action.payload.items || [];
      state.brands = {
        ...action.payload,
        items: [...stStores, ...payLoadStores],
      };
    }
  },
};

const brandsSlice = createSlice({
  name: 'IBrandState',
  initialState: initialStoreState,
  reducers: reducers,
});

export default brandsSlice.reducer;
export const BrandActions = brandsSlice.actions;
